<script setup lang="ts">
const page = usePage();
</script>

<template>
  <a :href="page.props.portal_base_url">
    <img
      v-bind="$attrs"
      target="_blank"
      src="@/assets/svg/logo.svg"
      draggable="false"
      alt="YouCan"
    >
  </a>
</template>

<style scoped>
img {
  user-select: none;
}
</style>
